(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brufords-test"] && !Shopify.designMode) return;
  try {
    
class LightboxCarousel {
  constructor(container) {
    this.container = container;
    this.track = container.querySelector('[data-carousel-track]');
    if (!this.track) return;

    this.slides = Array.from(this.track.children);
    this.prevButton = container.querySelector('[data-carousel-prev]');
    this.nextButton = container.querySelector('[data-carousel-next]');
    this.dotsContainer = container.querySelector('[data-carousel-dots]');
    this.dots = this.dotsContainer ? Array.from(this.dotsContainer.children) : [];

    this.currentIndex = 0;
    this.slideCount = this.slides.length;
    if (this.slideCount <= 1) return; // No need for JS if 1 or 0 slides

    this.isDragging = false;
    this.startX = 0;
    this.currentTranslate = 0;
    this.prevTranslate = 0;

    this.bindEvents();
    this.updateUI();
  }

  bindEvents() {
    this.prevButton.addEventListener('click', this.prevSlide.bind(this));
    this.nextButton.addEventListener('click', this.nextSlide.bind(this));

    this.dots.forEach(dot => {
      dot.addEventListener('click', () => {
        this.goToSlide(parseInt(dot.dataset.carouselDotIndex));
      });
    });

    // Touch events
    this.track.addEventListener('touchstart', this.touchStart.bind(this), { passive: true });
    this.track.addEventListener('touchmove', this.touchMove.bind(this), { passive: true });
    this.track.addEventListener('touchend', this.touchEnd.bind(this));
    
    // Mouse drag events (for desktop)
    this.track.addEventListener('mousedown', this.touchStart.bind(this));
    this.track.addEventListener('mousemove', this.touchMove.bind(this));
    this.track.addEventListener('mouseup', this.touchEnd.bind(this));
    this.track.addEventListener('mouseleave', this.touchEnd.bind(this));
    
    // Prevent image dragging
    this.track.addEventListener('dragstart', (e) => e.preventDefault());
  }

  touchStart(e) {
    this.isDragging = true;
    this.startX = this.getEventPositionX(e);
    this.track.style.transition = 'none'; // Disable transition while dragging
    this.prevTranslate = this.currentIndex * -this.slides[0].offsetWidth;
  }

  touchMove(e) {
    if (!this.isDragging) return;
    
    const currentPosition = this.getEventPositionX(e);
    this.currentTranslate = this.prevTranslate + currentPosition - this.startX;
    
    // Set a subtle resistance when swiping past bounds
    if (this.currentTranslate > 0 || this.currentTranslate < (this.slideCount - 1) * -this.slides[0].offsetWidth) {
      this.currentTranslate = this.prevTranslate + (currentPosition - this.startX) / 3;
    }
    
    this.setTrackPosition(this.currentTranslate);
  }

  touchEnd(e) {
    if (!this.isDragging) return;
    
    this.isDragging = false;
    this.track.style.transition = 'transform 0.4s cubic-bezier(0.68, -0.55, 0.27, 1.55)';
    
    const movedBy = this.currentTranslate - this.prevTranslate;
    const slideWidth = this.slides[0].offsetWidth;

    // Determine if swipe was significant enough
    if (movedBy < -slideWidth / 4 && this.currentIndex < this.slideCount - 1) {
      this.nextSlide();
    } else if (movedBy > slideWidth / 4 && this.currentIndex > 0) {
      this.prevSlide();
    } else {
      // Snap back to current slide
      this.goToSlide(this.currentIndex);
    }
  }

  getEventPositionX(e) {
    return e.type.includes('mouse') ? e.pageX : e.touches[0].clientX;
  }

  prevSlide() {
    this.goToSlide(this.currentIndex - 1);
  }

  nextSlide() {
    this.goToSlide(this.currentIndex + 1);
  }

  goToSlide(index) {
    if (index < 0) {
      this.currentIndex = 0;
    } else if (index >= this.slideCount) {
      this.currentIndex = this.slideCount - 1;
    } else {
      this.currentIndex = index;
    }
    
    this.setTrackPosition(this.currentIndex * -this.slides[0].offsetWidth);
    this.updateUI();
  }
  
  setTrackPosition(position) {
    this.track.style.transform = `translateX(${position}px)`;
  }

  updateUI() {
    // Update dots
    this.dots.forEach((dot, index) => {
      dot.classList.toggle('lightbox-section__dot--active', index === this.currentIndex);
    });

    // Update button states (disable at ends)
    this.prevButton.disabled = this.currentIndex === 0;
    this.nextButton.disabled = this.currentIndex === this.slideCount - 1;
  }
}

// Shopify section load/unload events
document.addEventListener('shopify:section:load', (event) => {
  const container = event.target.querySelector('.lightbox-section');
  if (container) {
    new LightboxCarousel(container);
  }
});

// Initial load for sections already on the page
document.querySelectorAll('.lightbox-section').forEach(container => {
  new LightboxCarousel(container);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
